import React, { memo, useEffect, useRef } from 'react';
import { buildInteractiveResult } from '@coveo/headless/product-listing';
import { useAnalyticsContext } from '../../../../config/GoogleTagManagerEvents';
import useAnalytics from '../../../../hooks/useAnalytics';
import AddToCartProductTileReact from '../../../global/modules/productTile/addToCartProductTileReact';
import { productListingEngine } from '../../Engine';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../constants/analyticsConstants/Ecommerce';

function ProductListing(props) {
    const { productList, totalCount } = props;
    const [{ payloadEcommercePageData, sendAnalyticsForProductCardEvent }] = useAnalytics();
    const { sendEventsForEcommercePageData } = useAnalyticsContext();
    const interactiveResultsRef = useRef({});

    useEffect(() => {
        if (productList?.products?.length > 0) {
            let lastItem = productList?.products[productList?.products?.length - 1];
            sendEventsForEcommercePageData(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_DATA,
                payloadEcommercePageData(
                    lastItem?.additionalFields?.ec_category
                        ? [
                            lastItem?.additionalFields?.ec_category[0],
                            lastItem?.additionalFields?.categoryl2,
                            lastItem?.additionalFields?.categoryl3
                        ]
                        : [lastItem?.additionalFields?.categoryl2, lastItem?.additionalFields?.categoryl3],
                    totalCount
                )
            );
        }
    }, []);

    useEffect(() => {
        if (productList?.products?.length < 4) {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 0);
        }
    }, [productList?.products]);

    const sendDataToCoveo = catClass => {
        const interactiveResult = interactiveResultsRef.current[catClass];
        if (interactiveResult && interactiveResult.select) {
            interactiveResult.select();
        }
    };

    const renderProductTiles = () => {
        return productList?.products?.map((item, index) => {
            const newInteractiveResult = buildInteractiveResult(productListingEngine, {
                options: {
                    result: {
                        ...item
                    }
                }
            });
            interactiveResultsRef.current[item?.additionalFields?.ec_skus[0]] = newInteractiveResult;
            const cardData = {
                catclass: item?.additionalFields?.ec_skus[0],
                producttitle: item?.ec_name,
                productimageurl: item?.additionalFields?.ec_primary_image,
                producturl: item?.additionalFields?.ec_product_url,
                showonlinecatalog: item?.additionalFields?.ec_show_onlinecatalog === '1' ? 'YES' : 'NO',
                disableaddtocartoption: item?.additionalFields?.ec_disable_addtocartoption === '1' ? 'YES' : 'NO',
                categoryname: item?.additionalFields?.ec_category ? item?.additionalFields?.ec_category[0] : '',
                productcategoryname: item?.additionalFields?.categoryl2,
                subcategoryname: item?.additionalFields?.categoryl3,
                position: index + 1,
                category_path: item?.additionalFields?.ec_category
                    ? [
                        item?.additionalFields?.ec_category[0],
                        item?.additionalFields?.categoryl2,
                        item?.additionalFields?.categoryl3
                    ]
                    : [item?.additionalFields?.categoryl2, item?.additionalFields?.categoryl3],
                catsku: item?.additionalFields?.ec_skus[0],
                catid: item?.additionalFields?.ec_category_id,
                metatitle: item?.additionalFields?.ec_meta_title,
                metadescription: item?.additionalFields?.ec_meta_description,
                specialtytypes: item?.additionalFields?.ec_specialtytypes,
                inventory: item?.additionalFields?.ec_pc_inventory,
                specialtytypescode: item?.additionalFields?.ec_specialtytypecode,
                analysisgroupcode: item?.additionalFields?.ec_analysisgroupcode
            };
            return (
                <div key={item?.additionalFields?.ec_skus[0]} className="col-md-3 col-lg-4 col-6 plp__item">
                    <AddToCartProductTileReact
                        cardData={cardData}
                        handleClick={() => sendDataToCoveo(cardData?.catclass)}
                        trackAnalytics={sendAnalyticsForProductCardEvent}
                    />
                </div>
            );
        });
    };
    return (
        <>
            <div className="row plp__list">{renderProductTiles()}</div>
        </>
    );
}

export default memo(ProductListing);
